export enum RequestType {
    STOCK_SWAP = 'stock swop',
    PR_CALL_REQUEST = 'pr call request',
    SAVE_OFFFER_REQUEST = 'save offer request',
    CALL_ESCALATION_REQUEST = 'call escalation',
    SPECIAL_PROJECT_REQUEST = 'special project call',
    TECHNICAL_SERVICECALL_DISCOUNT = 'technical servicecall discount',
    THIRD_PARTY_SUBCONTRACTOR = 'third-party subcontractor',
    INSPECTION_FORM_APPROVAL = 'inspection form',
    INSPECTION_ESCALATION_APPROVAL = 'inspection escalation',
    RATE_OUR_SERVICE = 'rate our service',
    TECHNICIAN_INCENTIVE = 'technician incentive',
    TECHNITIAN_INCENTIVE_SCHEME = 'technician incentive scheme',
    RATE_OUR_SERVICE_FOLLOWUP = 'rate our service follow up',
    VIDEOFIED_SIM_CARD_REQUEST = 'videofied sim card request',
    VIDEOFIED_SIM_CARD_OVERDUE = 'videofied sim card overdue',
    VIDEOFIED_SIM_CARD_RETURN_FOLLOWUP = 'videofied sim card return follow-up',
    INSTALLATION_PRE_CHECK = 'installation pre-check',
    NO_SIGNAL_REQUEST = 'no signal request',
    INSTALLATION_CALL_REQUEST = 'installation call request',
    SM_INTERVENTION = 'sm intervention',
    SM_CANCELLATION = 'sm cancellation',
    OUT_OF_OFFICE = 'out of office',
    OUT_OF_OFFICE_REQUEST = 'out of office request',
    ERB_EXCLUSION = 'erb exclusion',
    INTER_TECH_TRANSFER_REQUEST = 'inter tech transfer request',
    STOCK_TAKE_ESCALATION = 'stock take escalation',
    VISIBILITY_LOGGING = 'visibility patrol',
    SIGNAML_TAGGING = 'signal tagging',
    ZONE_SUSPEND = 'zone suspend',
    PROFILE_CHANGE = 'profile change',
    HOLIDY_INSTRUCTION = 'holiday instruction',
    FRIDGE_REMINDER = 'fridge reminder',
    PR_CALL = 'pr call',
    VIP_CLIENT = 'vip client',
    INCIDENT = 'incident',
    NOACESS_PERMICES = 'no access to premises',
    ACKNOWLEDGE_OF_DEBT = 'acknowledge of debt',
    PAYROLL_NUMBER = 'payroll number',
    DEALER_CUSTOMER = 'dealer customer',
    TECHNICAL_AREA_INVOICE_DISPUTE = 'technical invoice dispute',
    DEALER_CUSTOMER_VERIFICATION = 'dealer customer verification',
    DIRECT_SALE_DISCOUNT = 'direct sale discount',
    CUSTOMER_COORDINATES_CONFIRMATION = 'customer coordinates confirmation',
    STOCK_BIN_MOVEMOVEMENT = 'stock bin movement',
    BIN_LOCATION_UNASSIGN = 'bin location unassign',
    RADIO_REMOVAL_TRANSFER_REQUEST = 'radioremovaltransferrequest',
    REQUISITION_APPROVAL = 'requisition approval',
    RADIO_REMOVAL_ESCALATION = 'radio removal escalation',
    PAYMENT_METHOD = 'payment method',
    AUDIT_CYCLE_COUNT_ESCALATION = 'audit cycle count escalation',
    GEO_LOCATION_CO_ORDINATES_REQUEST = 'geo location co-ordinates request',
    RADIO_AND_CUSTOMER_GEO_LOCATION_VARIANCE = 'radio and customer geo location variance',
    INSPECTION_CALL_BACK = 'inspection call back',
    PSIRA_DATE_EXPIRY_ALERT = 'psira date expiry alert',
    CALL_ON_HOLD = 'call on hold',
    FAULTY = 'faulty',
    // REFUNDS   = 'refunds',
    TECHNICAL_UPSELLING_DISCOUNT = "technical upselling discount",
    FINAL_QUOTE = "final quote",
    WRITEOFF_AND_RECOVERY_REPORT = 'write off recovery report',
    STOCK_ORDER = "stock orders",
    // ITC_TRACE_REQUEST = 'itc trace request',
    UPSELLING_QUOTE = 'upselling quote',
    STANDBY_ROSTER = 'standby roster',
    TECHNICAL_UPSELLING_DECLINE = 'technical upselling decline',
    UPSELLING_QUOTE_PENDING = 'technical upselling pending',
    // EXTENDED_PAYMENT_ARRANGEMENT = 'extended payment arrangement',
    APPOINTMENT_ESCALATION = 'appointment escalation',
    INTER_BRANCH_STOCKORDER = 'interbranch stockorder',
    TECHNICIAN_TERMINATION = 'technician termination',
    CALL_AT_RISK_VOID = 'call at risk - void',
    AUTOMATICALLY_VOIDED_CALLS = 'automatically voided calls',
    TECHNICIAN_TEST_PASSWORD_RESET = 'technician test password reset',
    JOBS_TO_BE_AUTO_INVOICED = 'jobs to be auto invoiced',
    COMMS_TYPE_MONTHLY_FEE_SIGNALING_ISSUE = 'commsType-monthlyFee-signallingissue',
    COMMS_TYPE_MONTHLY_FEE_CUSTOMER_REQUEST = 'commsType-monthlyFee-customerrequest',
    REFER_TO_SALES_ESCALATION = 'refer to sales escalation',
    EXCESSIVE_RESCHEDULE_ESCALATION = 'excessive reschedule escalation',
    NKA_PURCHASE_ORDER_REQUEST = 'nka purchase order request',
    CUT_OFF_TIME_REACHED = 'cut off time reached',
    DIAGNOSIS_NOT_ASSIGNED = 'diagnosis not assigned',
    STOCK_ORDER_QUERY = 'stock order query',
    QUICK_ADD_SERVICE_CALL_NOT_SCHEDULED_VOIDED = 'quick add service call not scheduled/voided',
    MANUAL_RECEIVE_RECEIPT_STOCK = 'manual receive/receipt/issue stock',
    TECHNICAL_STOCK_ORDER_APPROVAL = 'technician stock order approval',
    STOCK_ORDER_NOT_COLLECTED = "stock order not collected after 24 hours",
    USE_TECHNICIAN_ORDER_STOCK_FOR_CUSTOMER_VIEW = 'use technician order stock for customer order',
    COUNTER_SALE_FOLLOWUP = 'counter sale followup',
    PICKED_ORDER_CANCELLED = 'picked order cancelled'
}
